export function compactDefinitionForOrchestrator(definition: any): {
  name: string;
  description: string;
  goals: string[];
  features: string[];
  inScope: string[];
  constraints: string[];
  assumptions: string[];
} {
  const source = definition ?? {};
  return {
    name: String(source?.name ?? ''),
    description: String(source?.description ?? '').slice(0, 500),
    goals: Array.isArray(source?.goals) ? source.goals.slice(0, 8) : [],
    features: Array.isArray(source?.features) ? source.features.slice(0, 12) : [],
    inScope: Array.isArray(source?.inScope) ? source.inScope.slice(0, 8) : [],
    constraints: Array.isArray(source?.constraints) ? source.constraints.slice(0, 8) : [],
    assumptions: Array.isArray(source?.assumptions) ? source.assumptions.slice(0, 8) : [],
  };
}
